import { ISearchEntityRequest } from "../models";
import * as path from "path";

export const DISBALED_FUND_PAGES = ["GB00BD6FFS27", "GB00BD6FFT34", "GB00BD3F7J05", "GB00BYRPBM49", "GB00BYRPBN55"];

// Leave the first two items in the typeahead array in order, search relies on it to be this way... SAY WHAAAT!!
export const TYPEAHEAD_SEARCH_VALUES = ["isin", "legal_name", "shareclass_display", "shareclass_currency_code", "shareclass_currency_name"];
export const INFINITE_SCROLL_LIMIT = 15;
export const LOADER_OPTIONS = { color: "#193769" };
export const IS_DEV = process.env.IS_DEV === void 0 ? false : process.env.IS_DEV;
export const BASE_SEARCH_REQUEST: ISearchEntityRequest = {
	type: "FUND",
	search: [],
	include: {
		allocations: {},
		statistics: {},
		commentaries: {},
		disclaimers: {},
		fundManagers: {},
		documents: {
			joinSpec: [
				{
					joinTo: "confluence_portfolio_id"
				}
			]
		}
	},
	culture: "en-GB",
	applyFormats: false,
	disclaimers: false,
	start: 0,
	limit: 100
};

export const colors = ['#C41232', '#D15A13', '#9A0E77', '#7A0016', '#FFA068', '#BE4DA2'];

import { getEnvironment } from "../utils/url";

export const ENVIRONMENT = getEnvironment();
export const ENDPOINTS = ENVIRONMENT.endpoints;

export const FILTER_FOCUS_PROPERTY = "__focus";

export const CONTACT_US_URL = {
	adv: "http://www.mandg.co.uk/adviser/request-form/",
	diw: "http://www.mandg.co.uk/discretionary/request-form/"
};


// WEBPACK FOOTER //
// ./src/client/config/base.ts